




















































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class OkModal extends Vue {
  @Prop() pTitle!: string;
  @Prop() pDiscountPrice!: number;
  @Prop() pUsageTarget!: string;
  @Prop() pTermsOfUse!: string;
  @Prop() pUsagePeriod!: string;
  @Prop() pNumberOfTimesOfUse!: number;
  @Prop() pOkMessage!: string;

  dialog = false;
  hovered = false;

  /**
   * モーダルの初期位置調整.
   */
  updated() {
    const element = document.querySelector<HTMLElement>(".v-dialog");
    if (!element) {
      return;
    }
    element.style.margin = "0";
  }

  open() {
    this.dialog = true;
  }

  cancel() {
    this.dialog = false;
  }

  ok() {
    this.dialog = false;
    this.$emit("ok");
  }
}
